export { default } from './ThemeProvider';
export { default as unstable_nested } from './nested';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/private-theming/ThemeProvider/index.js
// module id = 1113
// module chunks = 0